module.exports = __webpack_public_path__ + "static/front-17f3ee2bd0077f9cc3994df3c9682bd5.png";